module.exports = "/_next/static/images/apple-touch-icon-precomposed-f8d057d341b6d81d078f29a9cb763e1b.png";